import React from 'react';
import GenericNomenclatureList from './GenericNomenclatureList';
import { usePPETypeMutations } from '../../../hooks/useNomenclatures';

const PPETypeList = ({ items, onUpdate }) => {
  const mutations = usePPETypeMutations();

  const fields = [
    { 
      name: 'category', 
      label: 'Category', 
      type: 'select',
      options: ['Barrier', 'Respiratory', 'Eye/Face']
    },
    { name: 'requiredForIsolation', label: 'Required for Isolation', type: 'boolean' }
  ];

  return (
    <GenericNomenclatureList
      items={items}
      type="ppe-types"
      title="PPE Types"
      fields={fields}
      mutations={mutations}
      onUpdate={onUpdate}
    />
  );
};

export default PPETypeList;

